import { colorSystem } from "goi_common";

const title = "충청 대전 세종 장례 소개 포털";

export const parlorRegion = {
  defaultMetaData: {
    pageOgTitle: title + " :: 충청 대전 세종 지역 장례식장, 장지, 기초생활수급자 장례 혜택",
    pageDescription: `대전, 충청 내 모든 장례식장에 대해 둘러보세요. 근조화환, 실시간 빈소, 장례식장 비용 등 해당 장례식장에 필요한 정보들을 알아보세요.`,
    pageKeywords:
      "장례, 장례식, 가족장, 무빈소장례, 장례지도사, 장례식장, 장례 비용, 상조, 상조 회사, 상조회, 상조가입, 상조추천, 후불제상조, 장례상조, 상조서비스, 장례식 절차, 장례 절차, 임종, 고인, 빈소, 임종",
    pageOgDescription: `대전, 충청 내 모든 장례식장에 대해 둘러보세요. 근조화환, 실시간 빈소, 장례식장 비용 등 해당 장례식장에 필요한 정보들을 알아보세요.`,
    pageOgImage: "",
  },

  layout: {
    headTitle: title,
    layoutStyle: {
      background: "white",
      borderBottom: "none",
      color: "black",
      height: "60px",
    },
    ctaButtonStyle: {
      border: "none",
      color: "white",
      background: colorSystem.green.c400,
    },
  },

  targetSidos: ["25", "29", "33", "34"],

  regionColor: colorSystem.green,

  bestParlorIds: [77, 522, 536, 1080, 1156],

  baseUrl: "https://www.ch-funeralportal.co.kr",
};
